module.exports = __webpack_public_path__ + "static/landing-page-one-app-9c692ddb9e1f495eb250391b1a30cb8b.png";